import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Lock } from "lucide-react";
import FileUploader from "@/components/FileUploader";

export default function FieldEditor({ field, value, onChange, disabled = false }) {
  const labelEl = (
    <Label className="text-slate-700 text-xs font-semibold uppercase tracking-wider">
      {field.label}{field.required && <span className="text-red-500 ml-0.5">*</span>}
      {disabled && <span className="ml-1.5 inline-flex items-center gap-0.5 text-[9px] text-slate-400 normal-case font-normal"><Lock className="h-2.5 w-2.5" />locked</span>}
    </Label>
  );

  if (field.type === "textarea") {
    return (
      <div>
        {labelEl}
        <Textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="mt-1.5"
          rows={3}
          disabled={disabled}
          data-testid={`field-${field.key}`}
        />
      </div>
    );
  }

  if (field.type === "select" || field.type === "status") {
    return (
      <div>
        {labelEl}
        <Select value={value || ""} onValueChange={(v) => onChange(v)} disabled={disabled}>
          <SelectTrigger className="mt-1.5" data-testid={`field-${field.key}`}>
            <SelectValue placeholder="Select..." />
          </SelectTrigger>
          <SelectContent>
            {(field.options || []).map((o) => (
              <SelectItem key={o} value={o}>{o}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }

  if (field.type === "date") {
    return (
      <div>
        {labelEl}
        <Input
          type="date"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="mt-1.5"
          disabled={disabled}
          data-testid={`field-${field.key}`}
        />
      </div>
    );
  }

  if (field.type === "number" || field.type === "currency") {
    return (
      <div>
        {labelEl}
        <Input
          type="number"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
          className="mt-1.5"
          disabled={disabled}
          data-testid={`field-${field.key}`}
        />
      </div>
    );
  }

  if (field.type === "attachments") {
    if (disabled) {
      const files = Array.isArray(value) ? value : [];
      return (
        <div>
          {labelEl}
          <div className="mt-1.5 text-xs text-slate-500">
            {files.length ? `${files.length} file(s) attached (view from record page)` : "No attachments"}
          </div>
        </div>
      );
    }
    return (
      <div>
        {labelEl}
        <div className="mt-1.5">
          <FileUploader value={value || []} onChange={onChange} />
        </div>
      </div>
    );
  }

  return (
    <div>
      {labelEl}
      <Input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1.5"
        disabled={disabled}
        data-testid={`field-${field.key}`}
      />
    </div>
  );
}
